import { useNavigate } from "react-router-dom";

export default function StripeOnboardingDone() {
  const navigate = useNavigate();

  function handleClose() {
    // Intento 1: cerrar pestaña (solo funciona si fue abierta por JS/window.open)
    try {
      window.close();
    } catch (e) {}

    // Fallback: regresar atrás
    setTimeout(() => {
      if (window.history.length > 1) window.history.back();
      else navigate("/");
    }, 200);
  }

  return (
    <div style={wrap}>
      <div style={card}>
        {/* Cambia esto por tu logo real */}
        <img
          src="/logo.png"
          alt="MyShopCity"
          style={{ width: 90, height: 90, objectFit: "contain" }}
        />

        <h1 style={{ margin: "14px 0 6px" }}>¡Listo!</h1>
        <p style={{ margin: 0, opacity: 0.8, lineHeight: 1.5 }}>
          Gracias por registrarte en <b>Stripe</b>. Ya podemos realizar pagos a tu cuenta.
        </p>

        <div style={{ height: 12 }} />

        <p style={{ margin: 0, opacity: 0.85, lineHeight: 1.5 }}>
          Continúa en la app:
          <br />
          <b>cierra y abre</b> la sección de <b>Perfil</b> y podrás <b>subir productos</b>.
        </p>

        <button onClick={handleClose} style={btnPrimary}>
          Cerrar
        </button>

        <p style={{ marginTop: 10, fontSize: 12, opacity: 0.65 }}>
          Si el navegador no permite cerrar esta pestaña, vuelve con el botón “Atrás”.
        </p>
      </div>
    </div>
  );
}

const wrap = {
  minHeight: "100vh",
  display: "grid",
  placeItems: "center",
  padding: 16,
  background: "linear-gradient(180deg, rgba(0,0,0,0.04), rgba(0,0,0,0))",
};

const card = {
  width: "100%",
  maxWidth: 520,
  borderRadius: 18,
  padding: 22,
  background: "#fff",
  border: "1px solid rgba(0,0,0,0.08)",
  boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
  textAlign: "center",
};

const btnPrimary = {
  marginTop: 18,
  width: "100%",
  padding: "12px 14px",
  borderRadius: 12,
  border: "none",
  background: "#111827",
  color: "white",
  fontWeight: 800,
  cursor: "pointer",
};
